<template>
  <div class="login-modal spl">
    <div class="modal--wrapper" :class="{'modal-open': modalOpenState}">
      <div class="modal m-login-modal">
        <div class="modal--title">
          <div class="modal--title-text">{{$t('login-modal.title')}}</div>
          <div class="modal--title-subtext">{{$t('login-modal.subtitle')}}</div>
          <div class="modal--title-actions">
            <modal-close-btn @click="closeModal"/>
          </div>
        </div>
        <div class="modal--content" v-if="loading">
          <div class="loader">
            <loader/>
          </div>
        </div>
        <div class="modal--content" v-else>
          <div class="error" v-if="errorMail">
            <p>{{$t('login-modal.error.email_not_found')}}</p>
          </div>
          <div class="error" v-if="errorPassword">
            <p>{{$t('login-modal.error.password_error')}}</p>
          </div>
          <form action="" class="login-form">
            <div class="fields email">
              <email-input
                name="email"
                :placeholder="$t('login-modal.email')"
                v-model="emailInput"
              />
            </div>
            <div class="fields password">
              <password-input
                name="password"
                :placeholder="$t('login-modal.password')"
                v-model="passwordInput"
              />
            </div>
            <div class="fields login-texts">
              <p>
                {{$t('login-modal.texts.percent.0')}}
                <span>{{$t('login-modal.texts.percent.1')}}</span>
                {{$t('login-modal.texts.percent.2')}}
                <span>{{$t('login-modal.texts.percent.3')}}</span>{{$t('login-modal.texts.percent.4')}}
              </p>
              <p class="mb-0">
                <strong style="font-family: 'Sofia Pro Bold', sans-serif">
                  {{$t('login-modal.texts.contact.0')}}
                </strong><br>
                <span>{{$t('login-modal.texts.contact.1')}}</span>
              </p>
            </div>
            <div class="fields field-flex">
              <div class="flex-left">
                <checkbox-input :label="$t('login-modal.remember')" :default-checked="rememberMe" v-model="rememberMe" class="mt-0"/>
              </div>
              <div class="flex-right">
                <a class="grey-link" @click="openForgotModal">{{$t('login-modal.forgot')}}</a>
              </div>
            </div>
          </form>
        </div>
        <div class="modal--footer grid-footer-2" v-if="!loading">
          <router-link :to="{name: 'register'} " class="btn btn-secondary btn-full btn-std modal-btn"
                       v-on:click.native="closeModal" tag="button">{{$t('login-modal.createBtn')}}
          </router-link>
          <button class="btn btn-primary btn-full btn-std modal-btn" @click="send">{{$t('login-modal.login')}}</button>
        </div>
      </div>
    </div>


    <div class="modal--wrapper" :class="{'modal-open': forgot.modalOpenState}">
      <div class="modal m-forgot">
        <div class="modal--title">
          <div class="modal--title-text">{{$t('login-modal.reset')}}</div>
          <div class="modal--title-actions" v-if="!forgotLoading">
            <modal-close-btn @click="closeModal"/>
          </div>
        </div>
        <div class="modal--content spl" v-if="!forgotLoading">
          <div class="error" v-if="forgotErrors.length > 0">
            <p v-for="(item, index) in forgotErrors" :index="index" :key="item+index" :item="item">
              {{$t('login-modal.error.' + item.message)||item.message||item}}
            </p>
          </div>
          <p style="margin-bottom: 26px">{{$t('login-modal.resetMessage')}}</p>
          <form action="" class="login-form">
            <div class="fields email">
              <div class="error" v-if="emailError !== ''">
                {{this.emailError}}
              </div>
              <email-input
                @click="emailError = ''"
                name="forgot.email"
                :placeholder="$t('login-modal.email')"
                v-model="forgot.email"
              />
            </div>
          </form>
        </div>
        <div class="modal--content" v-else>
          <div class="loader">
            <loader/>
          </div>
        </div>
        <div class="modal--footer align-center" v-if="!forgotLoading">
          <button class="btn btn-primary btn-full modal-btn" :disabled="disableCheck" @click="sendReset">
            {{$t('login-modal.sendLink')}}
          </button>
          <div class="flex-center spl">
            <a class="grey-link" @click="closeForgotModal">{{$t('login-modal.back')}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import loader from './loader.component';
  import {mapState} from 'vuex';
  import TextInput from './text-input';
  import EmailInput from './email-input';
  import PasswordInput from './password-input';
  import CheckboxInput from './checkbox-input';
  import parseApiError from '../helpers/api-error-parser';
  import ModalCloseBtn from "./modal-close-btn";

  export default {
    name: 'login-modal',
    components: {ModalCloseBtn, CheckboxInput, PasswordInput, EmailInput, TextInput, loader},
    mounted() {
      window.addEventListener('app:login-modal.open', () => {
        this.openModal();
      });
    },
    data() {
      return {
        emailInput: '',
        passwordInput: '',
        rememberMe: true,
        emailError: '',
        forgot: {
          modalOpenState: false,
          email: '',
        },
      };
    },
    computed: {
      disableCheck() {
        return this.forgot.email === "" || this.emailError !== "";
      },
      ...mapState({
        modalOpenState: s => s.loginModal.openState,
        errorPassword: s => s.client.loginErrors.password,
        errorMail: s => s.client.loginErrors.email,
        loading: s => s.client.loading,
        forgotLoading: s => s.forgotPassword.loading,
        forgotErrors: s => s.forgotPassword.errors.map(parseApiError),
      }),
    },
    methods: {
      async sendReset() {
        if (this.validateEmail(this.forgot.email)) {
          await this.$store.dispatch('forgotPassword/send', this.forgot.email);
          if (this.forgotErrors.length === 0) {
            await this.$router.push({
              name: 'setNewPassword', props: {linkSend: true}, query: {email: this.forgot.email}
            });
            this.closeModal();
          }
        } else {
          this.emailError = this.$t('login-modal.emailError');
        }
      },
      validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      closeForgotModal() {
        this.forgot.modalOpenState = false;
        this.$store.commit('loginModal/OPEN');
      },
      openForgotModal() {
        this.forgot.modalOpenState = true;
        this.$store.commit('loginModal/CLOSE');
      },
      async send() {
        const response = await this.$store.dispatch('client/connect', {
          email: this.emailInput,
          password: this.passwordInput,
          rememberMe: this.rememberMe,
        });
        if (!this.errorPassword && !this.errorMail) {
          this.closeModal();
        }
      },
      closeModal() {
        if (this.loading) {
          return;
        }
        this.$store.commit('loginModal/CLOSE');
        this.forgot.modalOpenState = false;
      },
      openModal() {
        this.$store.commit('loginModal/OPEN');
      },
    },
  };
</script>

<style scoped>
  .spl {
    font-family: "Sofia Pro Light", sans-serif;
  }
  .fields:not(:first-child) {
    margin-top: 15px;
  }

  .loader {
    max-width: 140px;
    margin-left: calc(50% - 70px);
  }

  .form-control.errored {
    border-color: red;
  }

  div.error {
    color: red;
  }

  .modal--footer {
    flex-wrap: wrap;
    height: auto !important;
  }

  .pull-right {
    flex: 0 0 auto;
    margin: 10px 0 auto auto;
  }

  .grey-link {
    cursor: pointer;
    color: #606765;
    text-decoration: underline;
  }

  .field-flex {
    display: flex;
  }

  .flex-left {
    flex: 0 0 50%;
    margin: auto 0;
  }

  .flex-right {
    flex: 0 0 50%;
    text-align: right;
    margin: auto 0;
  }

  .flex-center {
    flex: 0 0 auto;
    margin: 20px auto auto auto;
  }

  .flex-right .grey-link {
    display: block;
    margin-top: 20px;
    height: 16px;
    line-height: 16px;
  }

  button:disabled {
    background-color: lightgray;
    border-color: lightgray;
  }

  button:disabled:hover {
    background-color: lightgray;
    border-color: lightgray;
  }

</style>



// WEBPACK FOOTER //
// src/components/login-modal.vue